import React from 'react';
import { Typography } from '@mui/material';

/**
 * Barion adattovábbítási nyilatkozat — a Barion feltételei szerint minden Barionos fizetés előtt
 * meg kell jeleníteni. A Barion székhelye a Barion hivatalos adatai szerint (2026-11).
 */
const BarionDataTransferNotice = ({ sx }) => (
  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ...sx }}>
    Tudomásul veszem, hogy a Wedigo Kft. (7635 Pécs, Bálicsi út 41/B) által a felhasználói adatbázisában tárolt
    alábbi személyes adataim átadásra kerülnek a Barion Payment Zrt. (1083 Budapest, Bókay János utca 44–46. C5 ép. 8. em.), mint adatfeldolgozó részére: név, e-mail cím, számlázási cím. Az adattovábbítás célja a fizetési
    tranzakciók lebonyolítása és a csalásmegelőzés. A Barion adatkezelési tájékoztatója:{' '}
    <a href="https://www.barion.com/hu/adatvedelmi-tajekoztato/" target="_blank" rel="noopener noreferrer">
      barion.com/hu/adatvedelmi-tajekoztato
    </a>.
  </Typography>
);

export default BarionDataTransferNotice;
